<script setup lang="ts">
import FiltrosObras from '@/components/FiltrosObras.vue';
import IconOpenReload from '@/components/icons/IconOpenReload.vue';
import Filtros from '@/services/model/filtros';
import { mapStores } from 'pinia';
import { defineComponent } from 'vue';
import obrasService from '@/services/obras.service';
import Swal from 'sweetalert2';
import { useObraStore } from '@/stores/obras';
import { useFiltrosStore } from '@/stores/filtros';
import { RouteState } from '@/router/routeState';
useObraStore();
</script>
<template>
    <div id="filter-sidebar-desktop" class="sidebar active-sidebar scrollable-content right-shadow-sidebar">
        <div class="d-flex justify-content-end pe-4" @click="recarregar">
            <IconOpenReload class="clickable" />
        </div>
        <div class="">
            <div class="filter-sidebar-desktop-height">
                <div class="d-flex flex-column flex-shrink-0 sidebar-holder ">
                    <div class="px-4 py-2 ">
                        <FiltrosObras :limpar="filtrosLimpar" />
                    </div>
                </div>
                <div class="d-flex justify-content-center mt-1 position-relative bottom-0">
                    <button class="btn btn-secondary botao-filtro text-uppercase" @click="aplicarFiltro">Aplicar</button>
                </div>
                <div class="mt-3"></div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">

export default defineComponent({
    name: 'FiltroDesktopView',
    data() {
        return {
            filtros: new Filtros(),
            filtrosLimpar: false,
            routeState: new RouteState()
        }
    },
    emits: ['filtro-aplicado'],
    computed: {
        ...mapStores(useObraStore),
        ...mapStores(useFiltrosStore)
    },
    watch: {
        'FiltrosStore.filtro': {
            handler(newValue: Filtros, oldValue: Filtros) {
            if (newValue != null)
                this.filtros = newValue;
            },
            deep: true
        }
    },
    mounted() {
        this.adicionarBarraRolagem();
        if (this.FiltrosStore.filtro != null)
            this.filtros = this.FiltrosStore.filtro;
    },
    methods: {
        async aplicarFiltro() {
            const response = await obrasService.pesquisarObras(this.filtros);
            if (response.data != null && response.data.length > 0) {
                this.ObraStore.update(response.data);
                this.$router.push({ name: this.routeState.lastValidRoute });
                this.$emit('filtro-aplicado')
            }
            else {
                Swal.fire('Ops...', 'Infelizmente a pesquisa não trouxe resultados');
            }
        },
        recarregar() {
            this.filtrosLimpar = !this.filtrosLimpar;
            this.aplicarFiltro();
        },
        adicionarBarraRolagem() {
            const filtro = document.querySelector('.filter-sidebar-desktop-height') as HTMLElement
            if (filtro !== null) {
                filtro.style.height = `${filtro.offsetHeight + 10}px`
            }
        }
    }
});
</script>
<style scoped>
.botao-filtro {
    border-radius: 0px;
    width: 150px;
    font-weight: bold;
}

.botao-filtro:hover {
    background-color: #164e79;
    border-color: #164e79;
}

.clickable {
    cursor: pointer;
}

.right-shadow-sidebar {
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.75);
    min-height: 100vh;
}
</style>